export const apiUrl = "https://dolphin-app-gv5vo.ondigitalocean.app/api";
// export const apiUrl = "http://localhost:1337/api";
// export const apiUrl = "https://api.simpleresto.ee";